import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3bbfcb4f")

_pushScopeId("data-v-3bbfcb4f")
const _hoisted_1 = {
  class: "px-16",
  style: {"z-index":"1"}
}
const _hoisted_2 = { class: "cat-title f-xl c-white f-bold t-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("WEEKLY")
const _hoisted_4 = { class: "f-nm sub-title ml-8" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("TOP 50")
const _hoisted_6 = { class: "prize p-16 mx-16" }
const _hoisted_7 = { class: "df-middle t-center" }
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("300g")
const _hoisted_10 = { class: "flex-1 divider dash" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("$13800")
const _hoisted_12 = { class: "df-middle controls mt-16" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Detail")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Results")
const _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "wedge",
  style: {"height":"40px"}
}, null, -1)
const _hoisted_16 = { class: "px-16 right" }
const _hoisted_17 = { class: "t-right" }
const _hoisted_18 = {
  class: "cat-title f-xl c-white f-bold t-center",
  style: {"padding-left":"20px"}
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("MONTHLY")
const _hoisted_20 = { class: "f-nm sub-title ml-8" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("TOP 50")
const _hoisted_22 = { class: "prize p-16 mx-16" }
const _hoisted_23 = { class: "df-middle t-center" }
const _hoisted_24 = { class: "flex-1" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("132g")
const _hoisted_26 = { class: "flex-1 divider dash" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("$14100")
const _hoisted_28 = { class: "df-middle controls mt-16" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Detail")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Results")
const _hoisted_31 = /*#__PURE__*/_createVNode("div", {
  class: "wedge",
  style: {"height":"40px"}
}, null, -1)
const _hoisted_32 = { class: "px-16" }
const _hoisted_33 = {
  path: "",
  class: "cat-title f-xl c-white f-bold t-center"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("SEASON")
const _hoisted_35 = { class: "f-nm sub-title ml-8" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("TOP 50")
const _hoisted_37 = { class: "prize p-16 mx-16" }
const _hoisted_38 = { class: "df-middle t-center" }
const _hoisted_39 = { class: "flex-1" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("89g")
const _hoisted_41 = { class: "flex-1 divider dash" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("$10400")
const _hoisted_43 = { class: "df-middle controls mt-16" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Detail")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Results")
const _hoisted_46 = /*#__PURE__*/_createVNode("div", {
  class: "wedge",
  style: {"height":"40px"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode("p", _hoisted_2, [
          _createVNode(_component_t, { path: "cup_8" }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_t, { path: "cup_9" }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Pic, {
              src: "cup/wt/gold",
              width: "56",
              height: "56"
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "",
              class: "value"
            }, {
              default: _withId(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Pic, {
              src: "cup/wt/wallet",
              width: "56",
              height: "56"
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "",
              class: "value"
            }, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_RouterLink, {
            to: "/cup/wt/detail?type=1",
            class: "flex-1"
          }, {
            default: _withId(() => [
              _createVNode(_component_t, { path: "cup_10" }, {
                default: _withId(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            to: "/cup/wt/detail?type=1&tab=1",
            class: "flex-1 divider"
          }, {
            default: _withId(() => [
              _createVNode(_component_t, { path: "cup_11" }, {
                default: _withId(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_15,
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _createVNode("p", _hoisted_18, [
          _createVNode(_component_t, { path: "cup_12" }, {
            default: _withId(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_20, [
            _createVNode(_component_t, { path: "cup_13" }, {
              default: _withId(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _createVNode(_component_Pic, {
              src: "cup/wt/gold",
              width: "56",
              height: "56"
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "",
              class: "value"
            }, {
              default: _withId(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode(_component_Pic, {
              src: "cup/wt/wallet",
              width: "56",
              height: "56"
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "",
              class: "value"
            }, {
              default: _withId(() => [
                _hoisted_27
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode(_component_RouterLink, {
            to: "/cup/wt/detail?type=2",
            class: "flex-1"
          }, {
            default: _withId(() => [
              _createVNode(_component_t, { path: "cup_10" }, {
                default: _withId(() => [
                  _hoisted_29
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            to: "/cup/wt/detail?type=2&tab=1",
            class: "flex-1 divider"
          }, {
            default: _withId(() => [
              _createVNode(_component_t, { path: "cup_11" }, {
                default: _withId(() => [
                  _hoisted_30
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_31,
    _createVNode("div", _hoisted_32, [
      _createVNode("div", null, [
        _createVNode("p", _hoisted_33, [
          _createVNode(_component_t, { path: "cup_14" }, {
            default: _withId(() => [
              _hoisted_34
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_35, [
            _createVNode(_component_t, { path: "cup_15" }, {
              default: _withId(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("div", _hoisted_37, [
        _createVNode("div", _hoisted_38, [
          _createVNode("div", _hoisted_39, [
            _createVNode(_component_Pic, {
              src: "cup/wt/gold",
              width: "56",
              height: "56"
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "",
              class: "value"
            }, {
              default: _withId(() => [
                _hoisted_40
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_41, [
            _createVNode(_component_Pic, {
              src: "cup/wt/wallet",
              width: "56",
              height: "56"
            }),
            _createVNode(_component_t, {
              as: "p",
              path: "",
              class: "value"
            }, {
              default: _withId(() => [
                _hoisted_42
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("div", _hoisted_43, [
          _createVNode(_component_RouterLink, {
            to: "/cup/wt/detail?type=3",
            class: "flex-1"
          }, {
            default: _withId(() => [
              _createVNode(_component_t, { path: "cup_10" }, {
                default: _withId(() => [
                  _hoisted_44
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            to: "/cup/wt/detail?type=3&tab=1",
            class: "flex-1 divider"
          }, {
            default: _withId(() => [
              _createVNode(_component_t, { path: "cup_11" }, {
                default: _withId(() => [
                  _hoisted_45
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_46
  ], 64))
})